<template>
  <div class="text-no-wrap pos-rel">
    <!-- TODO tidy this up -->
    <!-- TODO UI: This currently doesn't show all the people that have permissions to the document, just the roles -->
    <ol-tooltip>
      <template v-slot:activator="{ on }">
        <span class="hidden-sm-and-down" style=" max-height: 20px; max-width: calc(100px + (150 - 100) * (100vw - 600px) / (1280 - 600) );" v-on="on">
          <div style="flex: 1" class="text-truncate">
            <template v-for="([key, value], index) in nonClientRoles">
              <span :key="(key || 'undef') + 'loader'" class="d-none">
                {{ $loadUser(value) + '' }}
              </span>
              <span
                :key="key || 'undef'"
                :style="'orer: ' + (value === assignedTo ? 0 : 1)"
                :class="{'font-weight-bold ': value === assignedTo}"
              ><span v-show="index>0">, </span>{{ $meIfMe(value, ($gnp(usersById, [value, 'name']) || '').replace(/^(.*?\s\w).*/,'$1') + '.') || '...' }}</span>
            </template>
          <!-- <span v-show="nonClientRolesCount > 1" style="order: 99; flex-shrink: 1;">+</span> -->
          </div>
        </span>
        <v-btn
          icon
          class=" hidden-md-and-up"
          small
          :color="assignedToMe ? 'primary' : 'secondary'"
          style="width: 28px;"
          v-on="on"
          @click=""
        >
          <v-icon small>
            mdi-account-multiple-outline
          </v-icon>
        </v-btn>
      </template>
      <table>
        <tbody>
          <tr v-for="([key, value]) in nonClientRoles" :key="key || 'undef'" class="text-left">
            <th>{{ _.startCase(key) }}:</th><td>{{ $meIfMe(value, ($gnp(usersById, [value, 'name']) || '')) || '...' }}</td>
          </tr>
        </tbody>
      </table>
    </ol-tooltip>
    <!--
    if it's not assignedToClient
      load the assignedTo user
      show the assignedTo user chip
        if it's me, make it darker
          just use 'me' as the short name
        show an icon too
        show a tooltip with the full name and role

     for all of the roles
       if not the client or assignedTo user
         load the role user
          show the role user chip, (hidden on content-sm with css)
          if it's me, make it darker
            just use 'me' as the short name
          show a tooltip with the full name and role

   -->

    <template v-if="false">
      <v-tooltip v-if="!assignedToClient" bottom>
        <span class="d-none">
          {{ $loadUser(assignedTo) + '' }}
        </span>
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-chip
              class="mr-1 "
              :outlined="!assignedToMe"
              small
              label
              :color="toMaterialStyle(assignedTo, 300 + (assignedToMe ? -100 : 0)).backgroundColor"
            >
              <span class="small black--text opac-65">
                <v-icon
                  small
                >
                  mdi-account-arrow-left-outline
                </v-icon>
                <span v-show="!assignedToClient">
                  {{ $meIfMe(assignedTo, ($gnp(usersById, [assignedTo, 'name']) || '').replace(/^(.*?\s\w).*/,'$1') + '.') || '...' }}
                </span>

              </span>

            </v-chip>
          </span>
        </template>
        <span>
          {{ $gnp(usersById, [assignedTo, 'name']) }} ({{ _.startCase(assignedToRole) }})
        <!--               <v-icon
                    small
                    color="white"
                  >
                    mdi-account-arrow-left-outline
                  </v-icon> -->
        </span>
      </v-tooltip>

      <template v-for="(value, key) in roles">
        <v-tooltip v-if="key !== 'client' && value !== assignedTo" :key="key || 'undef'" bottom>
          <span class="d-none">
            {{ $loadUser(value) + '' }}
          </span>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-chip
                small
                label
                :outlined="value !== $store.state.user.uid"
                :color="toMaterialStyle(value, 100 + (value === $store.state.user.uid ? 100 : 0)).backgroundColor"
                class="mr-1 doclist--other-roles"
              >
                <span class="small black--text opac-65">
                  {{ $meIfMe(value, ($gnp(usersById, [value, 'name']) || '').replace(/^(.*?\s\w).*/,'$1') + '.') || '...' }}
                </span>
              </v-chip>
            </span>
          </template>
          <span>
            {{ $gnp(usersById, [value, 'name']) }} ({{ _.startCase(key) }})
          </span>
        </v-tooltip>
      </template>
    </template>

    <template v-if="false">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span v-on="on"> <span class="d-none">
            {{ $loadUser(assignedTo) }}
          </span>MM</span>
        </template>
        <span>Marc</span>
      </v-tooltip>

      <template v-for="(value, key) in roles" v-if="false">
        <v-tooltip v-if="key !== 'client' && value !== assignedTo" :key="key || 'undef'" bottom>
          <span class="d-none">
            {{ $loadUser(value) + '' }}
          </span>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-avatar
                size="32"
                text
                class="ml-1"
                :color="toMaterialStyle(value, 300).backgroundColor"
                :style="value === $store.state.user.uid ? 'padding-bottom: 1px;': ''"
              >
                <span class="caption" :style="'color: ' + toMaterialStyle(value, 600).color">{{ $meIfMe(value, ($gnp(usersById, [value, 'name']) || '').replace(/(\b[\w])\w*\s?/g, '$1')) || '...' }}</span>
              </v-avatar>
            </span>
          </template>
          <span>
            {{ $gnp(usersById, [value, 'name']) }} ({{ _.startCase(key) }})
          </span>
        </v-tooltip>
      </template>
    </template>

    <v-tooltip v-if="false && nonClientRolesCount > 1" bottom>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <span class="small "> +{{ nonClientRolesCount - 1 }} other{{ nonClientRolesCount > 2 ? 's' : '' }}</span>
        </span>
      </template>
      <span> <template v-for="(value, key) in roles">
        <div v-if="key !== 'client'" :key="key || 'undef'" style="flex: 1;">
          <span class="opac-65 small">
            {{ _.startCase(key) }}
          </span><br>
          <span class="d-none">
            {{ $loadUser(value) + '' }}
          </span>
          <span class="">
            {{ $meIfMe(value, $gnp(usersById, [value, 'name'])) || 'loading...' }}
            <v-icon
              v-show="assignedTo === value"
              small
              color="white"
            >
              mdi-account-arrow-left-outline
            </v-icon>
          </span>
        </div>
      </template>
      </span>
    </v-tooltip>
  </div>
</template>

<script>

import startCase from 'lodash/startCase'
import toMaterialStyle from '@/utils/toMaterialStyle'

const _ = { startCase }

export default {
  name: 'People',
  props: {
    assignedTo: { type: String, default: '' },
    assignedToClient: { type: Boolean, default: false },
    assignedToMe: { type: Boolean, default: false },
    assignedToRole: { type: String, default: '' },
    nonClientRolesCount: { type: Number, default: 0 },
    roles: { type: Object, default: () => ({}) }
  },
  data: () => ({
    peopleTooltip: null
  }),
  computed: {
    nonClientRoles () {
      return Object.entries(this.roles)
        .filter(([key, value]) => key !== 'client')
        .sort(([aKey, aValue], [bKey, bValue]) => { return aValue === this.assignedTo ? -1 : 1 })
    }
  },
  beforeCreate () {
    this.mapStates(['user'])
    this.mapGetters(['usersById'])
    this._ = _
    this.toMaterialStyle = toMaterialStyle
  }
}
</script>

<style lang="scss" scoped>

</style>
